import React, { Component } from 'react'
import { Form, Input, Button } from 'antd'

const layout = {
  labelCol: {
    md: {
      span: 4
    }
  },
  wrapperCol: {
    md: {
      span: 6
    }
  }
}

class SettingsProfileForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.updateUser(values.firstName, values.lastName, values.email)
      }
    })
  }

  render () {
    const { user } = this.props
    const { getFieldDecorator } = this.props.form

    return (
      <div className='page-settings__form'>
        <Form onSubmit={this.handleSubmit} className='form'>
          <fieldset className='fieldset form__fieldset'>
            <legend className='legend fieldset__legend'>My User Profile</legend>
            <Form.Item {...layout} label='First Name'>
              {getFieldDecorator('firstName', {
                rules: [{ required: true,
                  message: 'Please input your first name',
                  max: 320
                }],
                initialValue: user.info.firstName
              })(
                <Input name='firstName' maxLength={320} />
              )}
            </Form.Item>
            <Form.Item {...layout} label='Last Name'>
              {getFieldDecorator('lastName', {
                rules: [{
                  required: true,
                  message: 'Please input your last name',
                  max: 320
                }],
                initialValue: user.info.lastName
              })(
                <Input name='lastName' maxLength={320} />
              )}
            </Form.Item>
            <Form.Item {...layout} label='Email'>
              {getFieldDecorator('email', {
                rules: [{
                  required: true,
                  message: 'Please input your email',
                  max: 320,
                  pattern: /^\S+@\S+\.\S+$/
                }],
                initialValue: user.info.email
              })(
                <Input name='email' type='email' maxLength={320} disabled />
              )}
            </Form.Item>
          </fieldset>
          <Form.Item>
            <Button type='indigo' htmlType='submit' loading={user.isUpdating} disabled={user.isUpdating}>Update Profile</Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

export default Form.create()(SettingsProfileForm)



// WEBPACK FOOTER //
// ./src/views/Settings/components/ProfileForm/ProfileForm.jsx